'use client';

import { Button, ModalOverlay, ModalContent, Modal, ModalBody, Box, Flex, Text } from '@chakra-ui/react';
import { useKeyDown } from '@react-hooks-library/core';
import { useState } from 'react';
import type { IconType } from 'react-icons';
import { BiSearch, BiX } from 'react-icons/bi';
import { BsShift } from 'react-icons/bs';

import SearchBar from 'ui/snippets/searchBar/SearchBar';

export type SearchItem = {
  title: string;
  href: string;
  filter?: string;
  type?: string;
  icon?: IconType;
};

export const SearchButton = () => {
  const [ modalOpen, setModalOpen ] = useState(false);

  const handleSearch = () => {
    setModalOpen(true);
  };

  useKeyDown([ 'Shift', 'F' ], (e: KeyboardEvent) => {
    if (e.key === 'F' && e.shiftKey) {
      handleSearch();
    }
    e.preventDefault();
  });

  useKeyDown([ 'Escape' ], (e: KeyboardEvent) => {
    setModalOpen(false);
    e.preventDefault();
  });

  return (
    <Flex flex="1" justify={{ base: 'flex-end', lg: 'flex-start' }} gap="1.5">
      <Button
        onClick={ handleSearch }
        variant="empty"
        display="flex"
        alignItems="center"
        gap={ 2 }
        sx={{
          ':focus-visible': {
            boxShadow: 'none',
          },
        }}
      >
        <BiSearch size={ 14 }/>
        <Box display={{ base: 'none', md: 'block' }} fontSize="sm">Search</Box>
        <Flex
          ml={ 2 }
          gap={ 1 }
          borderRadius="lg"
          bg="whiteAlpha.50"
          px={ 3 }
          py={ 1.5 }
          color="whiteAlpha.800"
          fontSize="xs"
          alignItems="flex-start"
        >
          <BsShift size={ 14 }/>
          <Text>F</Text>
        </Flex>
      </Button>
      <Modal
        isOpen={ modalOpen }
        onClose={ () => setModalOpen(false) }
        size={{ base: 'full', lg: 'sm' }}
      >
        <ModalOverlay/>
        <ModalContent bg="#171717" sx={{ paddingTop: '55px !important' }}>
          <ModalBody m={ 0 } p={ 0 } paddingTop={ 0 }>
            <Box display={{ base: 'block', lg: 'none' }}>
              <Button
                onClick={ () => setModalOpen(false) }
                variant="outline"
                size="sm"
                bg="#171717"
                border="none"
                color="whiteAlpha.800"
                position="absolute"
                top={ 2 }
                right={ 2 }
              >
                <BiX size={ 20 }/>
              </Button>
            </Box>
            <SearchBar isHomepage={ false }/>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Flex>
  );
};
